import { render, staticRenderFns } from "./AuxiliaryIncome.vue?vue&type=template&id=273a9c27&scoped=true&"
import script from "./AuxiliaryIncome.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryIncome.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryIncome.vue?vue&type=style&index=0&id=273a9c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a9c27",
  null
  
)

export default component.exports